/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { useCallback, useEffect } from 'react';
import { Insights } from './insights';
import { SUMMARY_DASHBOARD_UTR_TABLE } from '../../constants/usage-slots';
import { getSummaryUtrTable } from '../../selectors';
import { useParams } from 'react-router-dom';
import { loadUniversalTrackerValues } from '../../actions/universalTracker';
import { useAppDispatch, useAppSelector } from '../../reducers';

const utTableUsage = SUMMARY_DASHBOARD_UTR_TABLE;


const Summary = ({ readOnly = false }: { readOnly: boolean }) => {

  const dispatch = useAppDispatch();
  const params = useParams<{ surveyId?: string, sdgCode?: string, initiativeId?: string }>();

  const { surveyId, sdgCode: urlSdgCode } = params;
  const [sdgCode, setSDGCode] = React.useState(urlSdgCode);

  const initiativeId = params.initiativeId;

  const handleSDGChange = useCallback((sdgCodes) => {
    setSDGCode(Array.isArray(sdgCodes) ? sdgCodes[0] : sdgCodes)
  }, [setSDGCode]);

  useEffect(() => {
    dispatch(loadUniversalTrackerValues(true, surveyId ?? ''))
  }, [dispatch, surveyId])

  useEffect(() => {
    // Reset selected sdg on surveyId or initiativeId change, except when code is set in url
    handleSDGChange(undefined);
  }, [handleSDGChange, initiativeId, surveyId])

  const utrTable = useAppSelector(getSummaryUtrTable);

  if (!initiativeId) {
    return <></>;
  }

  return <Insights
    utTableUsage={utTableUsage}
    readOnly={readOnly}
    initiativeId={initiativeId}
    surveyId={surveyId}
    sdgCode={sdgCode}
    handleSDGChange={handleSDGChange}
    utrTable={utrTable}
  />
}

export default Summary;
